import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as evaluationAPI from 'api/Evalution';

const initalState = {
  pagination: {
    pageSize: 15,
    currentPage: 1,
    totalRecords: null,
    index: 1
  },
  data: null,
  search: '',
  // totalRecord: null,
  ui: {
    loading: false,
    msg: '',
    downloadreport: {
      loading: false,
      status: 'initalState'
    }
  },
  evaluationPaylod: {},
  column: [],
  status: 'init',
  selected: {
    id: null,
    index: null,
    call_id: null
  },
  panelshow: true,
  hiddenColumns: [],
  allColumns: null,
  setHiddenColumns: null
};

const getEvaluationState = (state) => state.evaluation;

const getEvaluationData = createAsyncThunk('evaluation/getEvaluationData', async ({ filterResult, signal }) => {
  const res = await evaluationAPI.getEvaluationData(filterResult, signal);
  return res.data?.data;
});

const evaluationSlice = createSlice({
  name: 'evaluation',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
    },
    setPayload: (state, action) => {
      state.evaluationPaylod = action.payload;
    },
    setSearchText: (state, action) => {
      state.search = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
    },
    //   setPaginationData: (state, action) => {
    //     state.pagination = {
    //       pageSize: action.payload.pageSize,
    //       index: action.payload.index
    //     };
    //   },

    setSelectedPlayerView: (state, action) => {
      const { index, id, call_id } = action.payload;
      console.log('payload received', action.payload);
      if (index || id) {
        state.selected.id = id;
        state.selected.index = index;
        state.selected.call_id = null;
      } else if (call_id) {
        state.selected.call_id = call_id;
        state.selected.id = call_id;
        state.selected.index = null;
      }
      // if (index > state.pagination.pageSize - 1) {
      //   state.pagination.index = state.pagination.index + 1;
      //   state.selected.index = 1;
      // } else if (index < 0) {
      //   state.pagination.index = state.pagination.index - 1;
      //   state.selected.index = state.pagination.pageSize - 1;
      // } else {
      //   state.selected.index = index;
      // }
    },
    setPanelShow: (state, action) => {
      state.panelshow = action.payload;
    },
    setAllcolumn: (state, action) => {
      // state.hiddenColumns = action.payload.hiddenColumns;
      // state.setHiddenColumns = action.payload;
      state.allColumns = action.payload.MemoizedHeaders;
    },
    sethide: (state, action) => {
      state.hiddenColumns = action.payload;
      // if (!state.hiddenColumns.includes(action.payload)) {
      //   state.hiddenColumns.push(...action.payload);
      // } else {
      //   const index = state.hiddenColumns.indexOf(action.payload);
      //   if (index !== -1) {
      //     state.hiddenColumns.splice(index, 1);
      //   }
      // }
    }
  },
  extraReducers: {
    [getEvaluationData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getEvaluationData.fulfilled]: (state, action) => {
      console.log('actiondsf', action.payload);
      state.status = 'idle';
      state.ui.loading = false;
      state.data = action.payload?.basic_call_info;
      state.column = action.payload?.fields;
      state.pagination.totalRecords = action.payload.total_records;
    },

    [getEvaluationData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const { setSearchText, setPayload, sethide, setCurrentPage, setPageSize, setSelectedPlayerView, setPanelShow, setAllcolumn } = evaluationSlice.actions;

export default evaluationSlice.reducer;

export {
  setSearchText,
  sethide,
  getEvaluationState,
  getEvaluationData,
  setPayload,
  setPanelShow,
  setCurrentPage,
  setPageSize,
  setSelectedPlayerView,
  setAllcolumn
};
